// extracted by mini-css-extract-plugin
export var typingIndicator = "_pn-0";